import PropTypes from 'prop-types';

import ClearIcon from '@mui/icons-material/Clear';
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

const PhoneNumber = ({
  input: { onChange, value: inputValue, ...restInput },
  meta: { touched, error },
  disabled = false,
  showClearPhoneNumber = true,
  isFullWidth = true,
  placeholder,
}) => {
  const { t } = useTransl();
  const hasError = touched && !!error;
  return (
    <FormControl
      variant="outlined"
      size="small"
      error={hasError}
      disabled={disabled}
      fullWidth={isFullWidth}
    >
      <OutlinedInput
        {...restInput}
        type="text"
        error={hasError}
        endAdornment={
          showClearPhoneNumber && (
            <InputAdornment position="end">
              <IconButton
                aria-label={t('ariaLabel.clear')}
                onClick={() => (disabled ? {} : onChange(''))}
                edge="end"
                size="large"
                disabled={disabled}
              >
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }
        value={inputValue}
        onChange={({ target: { value } }) => onChange(value)}
        disabled={disabled}
        fullWidth={isFullWidth}
        placeholder={placeholder}
      />
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

PhoneNumber.propTypes = {
  input: PropTypes.instanceOf(Object),
  meta: PropTypes.instanceOf(Object),
  disabled: PropTypes.bool,
  showClearPhoneNumber: PropTypes.bool,
  isFullWidth: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default PhoneNumber;
